export const DEFAULT_STANDALONE_LOGIN_ROUTE = "/dash";

export type AppLoginRoute =
  "home" | "enroll" | "billing" | "documents" | "update_payment_method";

const APP_LOGIN_ROUTE_PATHS: Record<AppLoginRoute, string> = {
  home: "/dash",
  enroll: "/enroll",
  billing: "/dash/billing",
  documents: "/account/documents",
  update_payment_method: "/account/payment-method/update",
};

export function isAppLoginRoute(route: string): route is AppLoginRoute {
  return route in APP_LOGIN_ROUTE_PATHS;
}

export function appLoginRouteToPath(route: AppLoginRoute): string {
  return APP_LOGIN_ROUTE_PATHS[route];
}

export function appLoginRouteToPathOrDefault(
  route: string | null | undefined,
): string {
  if (route && isAppLoginRoute(route)) {
    return appLoginRouteToPath(route);
  }

  return DEFAULT_STANDALONE_LOGIN_ROUTE;
}

export function isEnrollRoute(route: string): boolean {
  return (
    route === "enroll" || route === "/enroll" || route.startsWith("/enroll/")
  );
}

export function resolveStandaloneLoginRoute(
  route: string | null | undefined,
  isEnrollmentFinalized: boolean,
): string {
  const destination = appLoginRouteToPathOrDefault(route);

  if (isEnrollmentFinalized && isEnrollRoute(route ?? destination)) {
    return DEFAULT_STANDALONE_LOGIN_ROUTE;
  }

  return destination;
}
